<template>
  <div>
    <Grid
      @api="getDeviceProfiles()"
      :headers="headers"
      :payload="gridPayload"
      @filter="showFilterModal = true"
      @clearFilters="$refs.desktopFilters.reset()"
    >
      <template #filter>
        <DeviceProfilesFilters ref="desktopFilters" />
      </template>

      <!-- Rows -->
      <template #body.company="{item}">
        <div :class="['flex flex-col lg:flex-row space-x-6 leading-5 font-medium']">
          {{ companies[item.company] }}
        </div>
      </template>
      <template #body.created_at="{item}">
        {{ item.created_at ? $d(new Date(item.created_at), 'long') : '-' }}
      </template>
      <template #body.actions="{item}">
        <base-button-icon
          @click="toggleDetailsRow(item.name)"
          tooltip="data"
          size="sm"
          class="bg-secondary-light"
          :icon="expandedRows.includes(item.name) ? `expand-up` : `expand-down`"
        />
      </template>

      <!-- Expansion row -->
      <template #expanded="{item}">
        <transition name="slidedown" class="slidedown transition-all">
          <div v-if="expandedRows.includes(item.name)" class="p-2 expanded-row-section">
            <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
              <base-card>
                <h3 class="self-center pb-2 text-base">Data</h3>
                <div class="overflow-y-auto" style="max-height: 250px">
                  <div
                    v-for="[header, value] of item.data.split('\n').map(e => e.split(':'))"
                    class="flex justify-between border-b pb-1 pr-1"
                  >
                    <span class="text-gray-500 device-profile-data-entry-header">
                      {{ header.split('_').join(' ') }}:</span
                    >
                    <span>{{ value }}</span>
                  </div>
                </div>
              </base-card>
            </div>
          </div>
        </transition>
      </template>
    </Grid>

    <!-- Mobile filters -->
    <transition v-if="showFilterModal" name="grow">
      <base-modal @close="showFilterModal = false" head="filters" bg="white" full-width>
        <DeviceProfilesFilters :mobile="true" ref="mobileFilter" />
        <!-- Action buttons -->
        <div class="pt-4 mt-6 border-t flex flex-col justify-end w-full">
          <div class="flex flex-col">
            <div class="flex space-x-4">
              <base-button
                class="w-1/2"
                @click="
                  $refs.mobileFilter.reset()
                  showFilterModal = false
                "
                action="clear"
                context="secondary"
              >
                <base-icon icon="close" />
              </base-button>
              <base-button
                class="w-1/2"
                @click="
                  $refs.mobileFilter.submit()
                  showFilterModal = false
                "
                action="submit"
              >
                <base-icon icon="filters" />
              </base-button>
            </div>
          </div>
        </div>
      </base-modal>
    </transition>
  </div>
</template>

<script>
import DeviceProfilesFilters from './DeviceProfilesFilters.vue'
import {
  BaseIcon,
  BaseCard,
  BaseCheck,
  BaseButton,
  BaseButtonIcon,
  BaseModal,
} from '@/components/base'
import Grid from '@/components/shared/Grid.vue'

export default {
  components: {
    Grid,
    BaseIcon,
    BaseCard,
    BaseCheck,
    BaseButton,
    BaseButtonIcon,
    DeviceProfilesFilters,
    BaseModal,
  },

  data() {
    return {
      headers: {
        name: {
          label: 'name',
          order: true,
        },
        module_type: {
          label: 'module_type',
          order: true,
        },
        module_version: {
          label: 'module_version',
          order: true,
        },
        company: {
          label: 'company',
          order: true,
        },
        created_at: {
          label: 'created',
          order: true,
        },
        actions: {
          label: '',
          order: false,
          className: 'lg:w-20',
        },
      },
      showFilterModal: false,
      expandedRows: [],
    }
  },

  computed: {
    companies() {
      const result = {}
      this.$store.getters['companies/list'].forEach(e => (result[e.id] = e.name))
      return result
    },
    paginationData() {
      return this.$store.getters['deviceProfiles/getPaginationData']
    },
    deviceProfiles() {
      return this.$store.getters['deviceProfiles/getDeviceProfiles']
    },
    gridPayload() {
      return {
        results: this.deviceProfiles,
        count: this.paginationData.count,
        next: this.paginationData.next,
        previous: this.paginationData.previous,
      }
    },
    isGwf() {
      return (
        !this.$store.getters['auth/currentUser'].companies ||
        this.$store.getters['auth/currentUser'].companies.length === 0
      )
    },
  },

  methods: {
    async getDeviceProfiles() {
      try {
        await this.$store.dispatch('deviceProfiles/getDeviceProfiles')
      } catch (e) {
        console.warn(e)
      }
    },

    toggleDetailsRow(name) {
      if (!this.expandedRows.includes(name)) {
        return this.expandedRows.push(name)
      }
      return this.expandedRows.splice(this.expandedRows.indexOf(name), 1)
    },

    text(field) {
      return this.$t(`mygwf.components.Grid.${field}`)
    },
  },
}
</script>

<style scoped>
.expanded-row-section {
  background-color: #f6f7f8;
}
.device-profile-data-entry-header:first-letter {
  text-transform: capitalize;
}
</style>
